import { RefObject, useEffect, useState } from "react";
import useEventListener from "./use-eventlistener"; // See: https://usehooks-ts.com/react-hook/use-event-listener

interface Size {
  width: number;
  height: number;
}

const useElementSize = <T extends HTMLElement>(ref: RefObject<T>, delayWindowResizeUpdate: number = 0): Size => {
  // console.log("custom hook run");
  const [size, setSize] = useState<Size>({
    width: 0,
    height: 0,
  });

  const handleSize = () => {
    const newWidth = ref.current?.offsetWidth;
    const newHeight = ref.current?.offsetHeight;

    if (size.width !== newWidth || size.height !== newHeight)
      setSize({
        width: newWidth ?? 0,
        height: newHeight ?? 0,
      });
  };

  useEventListener("resize", debounce(handleSize, delayWindowResizeUpdate));

  useEffect(() => {
    handleSize();
  });

  return size;
};

const debounce = <Callback extends (...args: Array<unknown>) => void>(fn: Callback, delay: number) => {
  let timer: ReturnType<typeof setTimeout> | null = null;
  return (...args: Parameters<Callback>) => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      fn(...args);
    }, delay);
  };
};

export default useElementSize;
